import React, { useState,  } from "react";
import SearchBar from "../../common/components/SearchBar";
import { useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux';
import CustomTable from "../../common/table/CustomTable";
import { PatientsAssignedDataFields, PatientsAssignedHeadCells,dashboardPatientsAssignedDataFields,dashboardPatientsAssignedHeadCells } from "./Constants";
import { useGetPatientByScope } from "../../../hooks/AppsReactQueryHooks/useGetPatientByScope";
import { ButtonGroup, Button } from "react-bootstrap";
import PatientSelection from "../../Admin/Dashboard/PatientSelection";
import {Row, Col} from "react-bootstrap";
import TextInput from "../../common/textfield/TextInput";
import SelectFiled from "../../common/textfield/SelectFiled";
import { useFormik } from "formik";
import { searchPatient } from "../api/Patient";
import { patientSelectionFormikObject } from "../../Admin/Dashboard/Constant";
import { DateSelectorWithoutFormik } from "../../common/textfield/DateSelector";
import moment from "moment";
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import { failed } from "../../common/Toastify";
import { getHCNAuthorityList } from "../../api/HCN";

function PatientsSearch(props) {
    const { isLoading, isFetching } = useGetPatientByScope({ onSuccess: (data) => { setPatientsAssigned(data) } })
    const [filterData, setFilterData] = useState([]);
    const [searchData, setSearchData]= useState([]);
    // const [btnActive, setBtnActive] = useState('assigned');
    const [btnLoading, setBtnLoading] = useState(false);
    const [page, setPage] = useState(0);
    const navigate = useNavigate();
    const [patientsAssigned, setPatientsAssigned] = useState([]);
    const dashboard = props.dashboard || false;
    const userOrganizationId = useSelector((state) => state?.auth?.user?.organizations?.[0]?.id);
    const organizations = props.organizations;
    const [orgId, setOrgId] = useState(userOrganizationId);
    
    const handleOrgChange = (event) => {
        let value = event?.target?.value;
        formik.setFieldValue("organization", value);
        setOrgId(value);
     }

    // const handleBtnChange = (val) => {
    //     setBtnActive(val);
    // }

    const handleDateChange = (val) => {
      if(val == null || val === "") { 
          formik.setFieldValue("birthDate", ""); 
      } 
      const momentDate = moment(val, 'MMM-DD-YYYY', true);
      const isValidDate = momentDate.isValid(); 
      
      if(isValidDate){
          formik.setFieldValue("birthDate", moment(val).format("MM-DD-YYYY")?.replace(/-/g,'/')); 
      } else{
          formik.setFieldValue("birthDate", val);
          formik.setFieldError("birthDate", 'Invalid date format'); 
      } 
    };

    const getHCNAuthorityType = async (orgId, healthCardAuthority) => {
        try {
            const res = await getHCNAuthorityList(orgId);
            const list = res?.data || [];
            const matched = list.find(item => item.authority === healthCardAuthority);
            return matched?.display || "-";
        } catch (error) {
            console.error("Error fetching HCN Authority List:", error);
            return "-";
        }
    };

    const formik = useFormik({
        initialValues: {
            firstName: "",
            lastName: "",
            birthDate: "",
            healthCardNumber: "",
            organization: ""
        },
        ...patientSelectionFormikObject,
        onSubmit: async (values) => {
          if(!values.firstName && !values.lastName && !values.birthDate && !values.healthCardNumber) {
            //setNoFilterError("There must be a least one search criteria, other than organization.")
            formik.setFieldError("allSearchFieldsEmpty", "There must be a least one search criteria other than organization");
            setBtnLoading(false);
            setSearchData([]);
            return;
          }
          formik.setFieldError("allSearchFieldsEmpty", undefined);
          setBtnLoading(true);
          try {
            const res = await searchPatient({ ...values, org_id: orgId });
            if (res.status === true) {
              const resWithAuthType = await Promise.all(
                res.result.map(async (patient) => {
                  const hcnIdentifier = patient?.identifier?.find(id => id.type === "HCN");
                  const authoritySystem = hcnIdentifier?.system;
                  const patientOrgID = patient?.orgId || patient?.managingOrganization?.[0]?.reference?.split('/')[1];
                  let authorityType = "-";
                  if (authoritySystem && patientOrgID) {
                    try {
                      authorityType = await getHCNAuthorityType(patientOrgID, authoritySystem);
                    } catch (err) {
                      console.error("Failed to fetch authority type for patient:", patient.id, err);
                    }
                  }
        
                  return {
                    ...patient,
                    authorityType: authorityType,
                  };
                })
              );
              console.log("Enriched Results:", resWithAuthType);
              setSearchData(resWithAuthType);
            } else {
              failed(res.error);
            }
          } catch (err) {
            failed(
              err?.response?.data?.message ||
              err?.response?.data?.error ||
              err.message
            );
          } finally {
            setBtnLoading(false);
          }
        },
      });

    const handleFilterData = (data) => {
        setFilterData(data)
    }

    // const handleView = (data) => {
    //     navigate("/app/patients-details", { state: { id: data?.id, name: data?.name[0]?.text, email: data?.telecom.find((element) => element.system == "email").value} })
    // };


    const handlePatientClick = (data) => {
      const baseUrl = window.location.origin;
      const patientId = data?.id;
      const url = `${baseUrl}/app/patients-details?patientId=${patientId}`
      window.open(url, "_blank");
    };

    const handleSearchPatient = (e)=>{
        e.preventDefault();
        setPage(0);
        !btnLoading && formik.handleSubmit();
      }

    const selectedUserAction = ({ action, data }) => {
        switch (action) {
            case "view":
                handlePatientClick(data)
                break;
            default:
                return null;
        }
    };
    
    return (
        <section className={dashboard? "dashboard patient-wrap" : "common-listing"}> 
            {dashboard && <><div style={{display:"flex", justifyContent: "flex-start"}}className="dashSearch">
                 <Row>
                    <Col>
                        <TextInput
                        keyField={"firstName"}
                        label={"First Name"}
                        formik={formik}
                        placeholder={"First Name"}
                        hideRequired={true}
                        />
                    </Col>
                    <Col>
                        <TextInput
                        keyField={"lastName"}
                        label={"Last Name"}
                        formik={formik}
                        placeholder={"Last Name"}
                        hideRequired={true}
                        />
                    </Col>
                    <Col>
                        <DateSelectorWithoutFormik
                            formik={formik}
                            keyField={'birthDate'}
                            label="DOB"
                            value={moment(formik.values.birthDate).format("YYYY-MM-DD")}
                            handleChange={handleDateChange}
                            isError={
                                formik?.touched?.end && formik?.errors?.end
                                ? formik?.errors?.end
                                : ""
                            }
                            maxDate={moment()}
                            hideRequired={true}
                        />
                    </Col>
                    {organizations.length >= 1 &&  <Col>
                      <SelectFiled
                        keyField={"organization"}
                        label={"Select Organization"}
                        selectLabel="Select"
                        formik={formik}
                        options={organizations}
                        isLoading={organizations?.length >= 1 ? false : true}
                        readOnly={organizations?.length >= 1 ? false : true}
                        hideRequired={true}
                        onChange={handleOrgChange}
                      />
                    </Col>}
                    <Col>
                        <TextInput
                        keyField={"healthCardNumber"}
                        label={"Patient Identifier"}
                        formik={formik}
                        placeholder={"Patient Identifier"}
                        hideRequired={true}
                        tooltip={"Searches for exact Patient Identifier match"}
                        />
                    </Col>
                    <Col>
                        <button
                            style={{height:"60px", marginTop:"26px", width: "fit-content"}}
                            className="custom-btn"
                            type="button"
                            isLoading={true}
                            onClick={handleSearchPatient}
                        >
                            <SearchOutlinedIcon/> Search
                        </button>
                        {formik.errors.allSearchFieldsEmpty && (
                          <div className="error-text">{formik.errors.allSearchFieldsEmpty}</div>
                        )}
                    </Col>
                </Row>
                </div>
                <CustomTable
                tableData={searchData}
                headCells={dashboardPatientsAssignedHeadCells}
                dataFields={dashboardPatientsAssignedDataFields}
                selectedUserAction={selectedUserAction}
                rowOptions={false}
                rowClick={dashboard}
                loading={btnLoading}
                fetching={isFetching}
                deletingItem={false}
                canView={true}
                canDelete={false}
                rowsPerPage={dashboard? 5 : 10}
                canEdit={false}
                page={page}
                setPage={setPage}
            /></>}
            {!dashboard && <>
                <div className="heading-wrap">
                    <SearchBar page={page} setPage={setPage} list={patientsAssigned} encoded={true} filterData={handleFilterData} />
                </div>
            
                <CustomTable
                    tableData={filterData}
                    headCells={dashboard ? dashboardPatientsAssignedHeadCells : PatientsAssignedHeadCells}
                    dataFields={dashboard ? dashboardPatientsAssignedDataFields : PatientsAssignedDataFields}
                    selectedUserAction={selectedUserAction}
                    rowOptions={false}
                    rowClick={dashboard}
                    loading={isLoading}
                    fetching={isFetching}
                    deletingItem={false}
                    canView={true}
                    canDelete={false}
                    rowsPerPage={dashboard? 5 : 10}
                    canEdit={false}
                    page={page}
                    setPage={setPage}
                />
                </>
            }  
        </section>
    );
}

export default PatientsSearch;